import { http } from "../http";

export const authLogin = (data: any) => {
  return http.post("/auth/login", data);
};


export const getUserProfile = () => {
  return http.post(`/auth/profile`);
};


export const getUsers = () => {
  return http.get("/users");
}; 

export const getUser = (id: string) => {
  return http.get(`/users/${id}`);
};

export const addUser = (data: any) => {
  return http.post("/users", data);
};

export const updateUser = (userId: string, data: any) => {
  return http.patch(`/users/${userId}`, data);
};

export const deleteUser = (userId: string) => {
  return http.delete(`/users/${userId}`);
};




// Folder 

export const getFolders = () => {
  return http.get("/folders");
};


// getFolderI
export const getFolderI = () => {
  return http.get("/folders/main/parents");
};

export const getFolder = (folderId: string) => {
  return http.get(`/folders/${folderId}`);
};




// createFolder 
export const createFolder = (data: any) => {
  return http.post("/folders", data);
};

// updateFolder 

export const updateFolder = (folderId: string, data: any) => {
  return http.patch(`/folders/${folderId}`, data);
};


// deleteFolder id
export const deleteFolder = (folderId: string) => {
  return http.delete(`/folders/${folderId}`);
};




export const FileUpload = (folderName: string, file: File) => {
  const formData = new FormData();
  formData.append('file', file); // Append the file to FormData
  return http.post(`/bunny/upload/${folderName}`, formData);
};


// delete File
export const deleteFile = (path: string) => {
  return http.delete(`/bunny/delete/${path}`);
};


export const AddFiletoFolder = ( data: any) => {
  return http.post(`/files`, data);
}

// Edit File in Folder
export const UpdateFileInFolder = (fileId: string, data: any) => {
  return http.put(`/files/${fileId}`, data);
};

//delete file in folder
export const DeleteFileInFolder = (fileId: string, folderId: string) => {
  return http.delete(`/files/${fileId}/folder/${folderId}`);
};



// export const FileUpload = (folderName: string, file: File, onProgress: (progress: number) => void) => {
//   const formData = new FormData();
//   formData.append('file', file);

//   return http.post(`/bunny/upload/${folderName}`, formData, {
//     onUploadProgress: (progressEvent) => {
//       if (progressEvent.total) {
//         const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//         onProgress(progress);
//       } else {
//         onProgress(0); // Default to 0 if total is undefined
//       }
//     },
//   });
// };
